import helper from './helper'

const teamReveal = {
    scrollInterval: null,
    init: function () {
        const $teamBoxes = $('.js-team-box'),
            $teamBoxWrap = $('.js-team-wrapper'),
            $complianceBox = $('.js-compliance-box')

        if ($teamBoxWrap.length) {
            $teamBoxWrap.on('click', '.js-team-box', function () {
                let $target = $(this)
                if ($target.hasClass('is-revealed')) {
                    $target.toggleClass('is-revealed')
                } else {
                    $teamBoxes.removeClass('is-revealed')
                    $target.toggleClass('is-revealed')
                }
            })

            $(window).on('click', function (ev) {
                let isTeamWrapper = $(ev.target).parents('.js-team-box')
                if (isTeamWrapper.length == 0 && ev.which) {
                    $teamBoxes.removeClass('is-revealed')
                }
            })

            $(window).on('resize scroll', () => {
                clearInterval(this.scrollInterval)
                this.scrollInterval = setTimeout(() => {
                    if (
                        !helper.isElementInViewport(
                            $teamBoxWrap,
                            'partialInView'
                        )
                    ) {
                        $teamBoxes.removeClass('is-revealed')
                    }
                    if (
                        !helper.isElementInViewport(
                            $complianceBox,
                            'partialInView'
                        )
                    ) {
                        $complianceBox.removeClass('is-revealed')
                    }
                }, 50)
            })
        }

        if ($complianceBox.length) {
            $complianceBox.on('click', function () {
                $(this).toggleClass('is-revealed')
            })

            $(window).on('click', function (ev) {
                let isComplianceBox = $(ev.target).parents('.js-compliance-box')
                if (isComplianceBox.length === 0 && ev.which) {
                    $complianceBox.removeClass('is-revealed')
                }
            })
        }
    },
}

teamReveal.init()
